
import React from 'react';

const Buildings = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M28 16h-5v-6c0-.43-.28-.81-.68-.95-.41-.14-.86 0-1.12.35L17 15V6c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v11l-1.2-1.6c-.38-.5-1.22-.5-1.6 0l-3 4c-.04.05-.06.11-.09.17l-.03.06c-.04.11-.06.22-.07.34 0 .01-.01.02-.01.03v6c0 .55.45 1 1 1h24c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1zm-1 2v1h-4v-1h4zm-20-.33L8 19H6l1-1.33zM5 21h4v4H8v-2H6v2H5v-4zm6-1V7h4v18h-4v-5zm6-1.67L21 13v12h-4v-6.67zM27 25h-4v-4h4v4z'
			></path>
			<path
				fill='#2d2d2d'
				d='M14 8h-2v2h2V8zM14 11h-2v2h2v-2zM14 14h-2v2h2v-2zM14 17h-2v2h2v-2zM14 20h-2v2h2v-2zM20 18h-2v6h2v-6zM26 22h-2v2h2v-2z'
			></path>
		</svg>
	);
};

export default Buildings;
